import { Helmet } from "react-helmet-async";

/**
 * Injects one or more JSON-LD <script> tags into the document head.
 * Accepts a single object or an array of structured-data objects.
 * Undefined / null / empty values are stripped before serialization.
 */
function stripEmpty(obj) {
  if (Array.isArray(obj)) return obj.map(stripEmpty).filter((v) => v !== undefined);
  if (obj && typeof obj === "object") {
    const out = {};
    for (const [k, v] of Object.entries(obj)) {
      const cleaned = stripEmpty(v);
      if (cleaned === undefined || cleaned === null || cleaned === "" || (Array.isArray(cleaned) && cleaned.length === 0)) continue;
      out[k] = cleaned;
    }
    return out;
  }
  return obj;
}

export function JsonLd({ data }) {
  if (!data) return null;
  const blocks = Array.isArray(data) ? data : [data];
  return (
    <Helmet>
      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(stripEmpty(block))}</script>
      ))}
    </Helmet>
  );
}
